// Localization index - exports all language files and types
import en from './en.json';
import zhCN from './zh-CN.json';
import es from './es.json';
import fr from './fr.json';
import de from './de.json';
import it from './it.json';
import ptBR from './pt-BR.json';
import ja from './ja.json';
import ko from './ko.json';
import ar from './ar.json';

export type SupportedLanguage =
  | 'en'
  | 'zh-CN'
  | 'es'
  | 'fr'
  | 'de'
  | 'it'
  | 'pt-BR'
  | 'ja'
  | 'ko'
  | 'ar';

export const SUPPORTED_LANGUAGES: {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
  dir: 'ltr' | 'rtl';
}[] = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'zh-CN', name: 'Chinese (Simplified)', nativeName: '简体中文', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', dir: 'ltr' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)', dir: 'ltr' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', dir: 'ltr' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
];

export const translations: Record<SupportedLanguage, typeof en> = {
  en,
  'zh-CN': zhCN,
  es,
  fr,
  de,
  it,
  'pt-BR': ptBR,
  ja,
  ko,
  ar,
};

export type TranslationKeys = typeof en;

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export function getTranslation(lang: SupportedLanguage): typeof en {
  return translations[lang] || translations[DEFAULT_LANGUAGE];
}

export function isRTL(lang: SupportedLanguage): boolean {
  return lang === 'ar';
}

export function getLanguageDirection(lang: SupportedLanguage): 'ltr' | 'rtl' {
  return isRTL(lang) ? 'rtl' : 'ltr';
}
